// 261010 P9D vòng sửa 1 (#6, I10) — gen tay ở Bank / thế giới nhúng trong bước 2 khi máy tự chạy đang chạy ⇒ BE 409 `WORKFLOW_RUN_ACTIVE`.
// Khung mới hiện câu có sẵn của `workflowActionError` + nút «Xem bước đang chạy»; KHÔNG retry, không lách sổ. Caller cũ (không bọc Provider) giữ nguyên `apiErrorText`. THUẦN (0 antd).
import { workflowActionError, type ActionError } from './workflowActionPolicy';

export const VIEW_RUNNING_LABEL = 'Xem bước đang chạy';

/** Trả lỗi đã dịch NẾU là 409 + code WORKFLOW_RUN_ACTIVE (mã nằm ở `response.data.code` hoặc `errorCode`); lỗi khác ⇒ null (caller dùng đường cũ). */
export function runActiveErrorOf(err: any, what: string): ActionError | null {
  if (err?.response?.status !== 409) return null;
  const d = err?.response?.data;
  const code = typeof d?.code === 'string' ? d.code : typeof d?.errorCode === 'string' ? d.errorCode : '';
  return code === 'WORKFLOW_RUN_ACTIVE' ? workflowActionError(err, what) : null;
}

/**
 * Quyết định thuần của reporter (vòng sửa 2 R2-1): có Provider (khung mới) VÀ lỗi đúng 409 `WORKFLOW_RUN_ACTIVE` ⇒ `RUN_ACTIVE` (câu policy + nút «Xem bước đang chạy»).
 * MỌI trường hợp còn lại (không Provider — UI cũ; hoặc lỗi khác) ⇒ `FALLBACK` = caller tự hiện ĐÚNG câu/kiểu cũ của nó (kể cả `e?.message || '…'` của WP6, duration 8 của gen look).
 */
export function bankErrorDecision(hasProvider: boolean, err: any, what: string): { mode: 'RUN_ACTIVE'; text: string } | { mode: 'FALLBACK' } {
  const busy = hasProvider ? runActiveErrorOf(err, what) : null;
  return busy ? { mode: 'RUN_ACTIVE', text: busy.text } : { mode: 'FALLBACK' };
}
